const themeColors = {
  redTheme: '#770202',
  yellowTheme: '#D4B000',
  greenTheme: '#084017',
  blueTheme: '#11334E',
  blackTheme: '#000000',
};

const getColorCode = (colorName) => themeColors[colorName] || null;

export default getColorCode;
